import { NgModule } from '@angular/core';

// Pipes
import { FriendlyBooleanPipe } from '@src/app/shared/pipes/friendlyBoolean.pipe';
import { ActiveInactivePipe } from '@src/app/shared/pipes/activeInactive.pipe';
import { StatusPipe } from '@src/app/shared/pipes/status.pipe';
import { WarrantyEndDatePipe } from '@src/app/shared/pipes/warrantyEndDate.pipe';
import { DefaultValuePipe } from '@src/app/shared/pipes/noData.pipe';
import { FormatAddressPipe } from '@src/app/shared/pipes/formatAddress.pipe';
import { LanguagePipe } from '@src/app/shared/pipes/portalLanguages.pipe';
import { WarrantyOperationTypePipe } from '@src/app/shared/pipes/warrantyOperationType.pipe';
import { EventTypePipe } from '@src/app/shared/pipes/eventType.pipe';
import { ItemLocationPipe } from '@src/app/shared/pipes/itemLocation.pipe';
import { ItemStatePipe } from '@src/app/shared/pipes/ItemState.pipe';
import { ConcatenateStringPipe } from '@src/app/shared/pipes/concatenateString.pipe';
import { FullUserNamePipe } from '@src/app/shared/pipes/fullUserName.pipe';
import { ShipmentItemStatePipe } from '@src/app/shared/pipes/shipmentItemState.pipe';
import { InventoryItemStatePipe } from '@src/app/shared/pipes/inventoryItemState.pipe';
import { ImportStatePipe } from '@src/app/shared/pipes/importState.pipe';
import { ImportTypePipe } from '@src/app/shared/pipes/importType.pipe';
import { ExportTypePipe } from '@src/app/shared/pipes/exportType.pipe';
import { ExportStatePipe } from '@src/app/shared/pipes/exportState.pipe';
import { CardOrderingStatusPipe } from '@src/app/shared/pipes/cardOrderingStatus.pipe';
import { CardOrderingItemStatusPipe } from '@src/app/shared/pipes/cardOrderingItemStatus.pipe';
import { DateConversionPipe } from '@src/app/shared/pipes/dateConversion.pipe';
import { CollectionNamesPipe } from '@src/app/shared/pipes/collectionNames.pipe';
import { SeparateArrayByCommasPipe } from '@src/app/shared/pipes/separateArrayByCommas';
import { OrderStatePipe } from '@src/app/shared/pipes/orderState.pipe';
import { OrderGenerationTypePipe } from '@src/app/shared/pipes/orderGenerationType.pipe';
import { OrderGenerationAlgorithmPipe } from '@src/app/shared/pipes/orderGenerationAlgorithm.pipe';
import { OrderOutputFormatPipe } from '@src/app/shared/pipes/orderOutputFormat.pipe';
import { SafePipe } from '@src/app/shared/pipes/safe.pipe';
import { GenderPipe } from '@src/app/shared/pipes/gender.pipe';
import { AttributeDataTypePipe } from '@src/app/shared/pipes/attributeDataType.pipe';
import { QuestionTypePipe } from '@src/app/shared/pipes/questionType.pipe';

@NgModule({
  imports: [],
  declarations: [
    ActiveInactivePipe,
    CardOrderingStatusPipe,
    CardOrderingItemStatusPipe,
    CollectionNamesPipe,
    ConcatenateStringPipe,
    DefaultValuePipe,
    ExportStatePipe,
    FormatAddressPipe,
    FriendlyBooleanPipe,
    FullUserNamePipe,
    LanguagePipe,
    StatusPipe,
    WarrantyEndDatePipe,
    WarrantyOperationTypePipe,
    EventTypePipe,
    ItemLocationPipe,
    ItemStatePipe,
    ShipmentItemStatePipe,
    InventoryItemStatePipe,
    ImportStatePipe,
    ImportTypePipe,
    ExportTypePipe,
    DateConversionPipe,
    SeparateArrayByCommasPipe,
    OrderStatePipe,
    OrderGenerationTypePipe,
    OrderGenerationAlgorithmPipe,
    OrderOutputFormatPipe,
    SafePipe,
    GenderPipe,
    AttributeDataTypePipe,
    QuestionTypePipe
  ],
  exports: [
    ActiveInactivePipe,
    CardOrderingStatusPipe,
    CardOrderingItemStatusPipe,
    CollectionNamesPipe,
    ConcatenateStringPipe,
    DefaultValuePipe,
    ExportStatePipe,
    FormatAddressPipe,
    FriendlyBooleanPipe,
    FullUserNamePipe,
    LanguagePipe,
    StatusPipe,
    WarrantyEndDatePipe,
    WarrantyOperationTypePipe,
    EventTypePipe,
    ItemLocationPipe,
    ItemStatePipe,
    ShipmentItemStatePipe,
    InventoryItemStatePipe,
    ImportStatePipe,
    ImportTypePipe,
    ExportTypePipe,
    DateConversionPipe,
    SeparateArrayByCommasPipe,
    OrderStatePipe,
    OrderGenerationTypePipe,
    OrderGenerationAlgorithmPipe,
    OrderOutputFormatPipe,
    SafePipe,
    GenderPipe,
    AttributeDataTypePipe,
    QuestionTypePipe
  ]
})
export class PipesModule { }
